module.exports = __webpack_public_path__ + "img/app_main.ccc74b35.png";